import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/Home.vue')
  },
  {
    path: '/my',
    name: 'My',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/home/My.vue')
  },
  // 卡权益
  {
    path: '/card-ecommend',
    name: 'Card-ecommend',
    component: () => import('../views/card/card-ecommend.vue')
  },
  // 买卡
  {
    path: '/buy-card',
    name: 'Buy-card',
    component: () => import('../views/card/buy-card.vue')
  },
  // 充值
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('../views/pay/Pay.vue')
  },
  // 分享
  {
    path: '/share',
    name: 'Share',
    component: () => import('../views/home/Share.vue')
  },
  // 完善个人信息
  {
    path: '/perfect',
    name: 'Perfect',
    component: () => import('../views/information/Perfect.vue')
  },
  // 订单列表
  {
    path: '/order-list',
    name: 'Order-list',
    component: () => import('../views/order/order-list.vue'),
  },
  // 订单详情
  {
    path: '/order-more',
    name: 'Order-more',
    component: () => import('../views/order/order-more.vue')
  },
  // 活动详情
  {
    path: '/activity-detail',
    name: 'Activity-detail',
    component: () => import('../views/activity/activity-detail.vue')
  },
  // 粉丝管理
  {
    path: '/fans',
    name: 'Fans',
    component: () => import('../views/fans/Fans.vue')
  },
  // 申请合伙人
  {
    path: '/apply-partner',
    name: 'Apply-partner',
    component: () => import('../views/partner/apply-partner.vue')
  },
  // 支付成功
  {
    path: '/pay-success',
    name: 'Pay-success',
    component: () => import('../views/pay/pay-success.vue')
  },
  // 卡权益
  {
    path: '/card-rights',
    name: 'Card-rights',
    component: () => import('../views/card/card-rights.vue')
  },
  // 充值记录
  {
    path: '/pay-record',
    name: 'Pay-record"',
    component: () => import('../views/pay/pay-record.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// router.beforeEach((to, from, next) => {
//   // ...
// })
export default router
